module.exports = __webpack_public_path__ + "img/unionpay.8eb2a0a5.svg";